import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Category } from '@classes/category/category';
import { environment } from '@environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CategoriesService {

  constructor(
    private http: HttpClient
  ) { }

  /* -------------------------------------------------------------------------- */
  /*                                     GET                                    */
  /* -------------------------------------------------------------------------- */

  getCategories(categoryListId: string): Observable<Category[]> {
    return this.http.get<Category[]>(`${environment.apiUrl}/categories?categoryListId=${categoryListId}`,
      {
        headers: { authorization: `Bearer ${localStorage.getItem(environment.tokenKey)}` }
      });

  }

  /* -------------------------------------------------------------------------- */
  /*                                    POST                                    */
  /* -------------------------------------------------------------------------- */


  /* -------------------------------------------------------------------------- */
  /*                                     PUT                                    */
  /* -------------------------------------------------------------------------- */


  /* -------------------------------------------------------------------------- */
  /*                                   DELETE                                   */
  /* -------------------------------------------------------------------------- */

}
